import Masthead from "./components/Masthead";
import BreakingStrip from "./components/BreakingStrip";
import HeroSpread from "./components/HeroSpread";
import TimelineFeed from "./components/TimelineFeed";
import FeatureStories from "./components/FeatureStories";
import HotRanking from "./components/HotRanking";
import TopicZones from "./components/TopicZones";
import BackstagePeek from "./components/BackstagePeek";
import ReaderVoice from "./components/ReaderVoice";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50 text-foreground-950">
      <Masthead />
      <main className="flex-1">
        <BreakingStrip />
        <HeroSpread />
        <TimelineFeed />
        <FeatureStories />
        <HotRanking />
        <TopicZones />
        <BackstagePeek />
        <ReaderVoice />
      </main>
      <SiteFooter />
    </div>
  );
}